import {useTranslation} from 'react-i18next'

// Geoprompt's plans are set by an account manager, not by the user: the
// subscription page says who to ask.
export function SubscriptionManagedNotice() {
  const {t} = useTranslation()
  return <span>{t('subscription.managed')}</span>
}
